import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { EmployeePositionApiService, GvTaTrackerAssignmentApiService } from '@shared/services';
import { GV_TA_SELECT_CONFIG, TRACKER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const assignGvTaTrackerFormConfig = (): FormConfig => {
    const employeePositionApiService = inject(EmployeePositionApiService);
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        fields: [
            {
                key: 'gvTaEmployeePositionId',
                label: 'GV/TA',
                required: true,
                width: 'full',
                type: 'select',
                config: { ...GV_TA_SELECT_CONFIG, service: employeePositionApiService },
                customErrorMessage: 'Vui lòng chọn GV/TA'
            },
            {
                key: 'trackerEmployeePositionId',
                label: 'Tracker',
                required: true,
                width: 'full',
                type: 'select',
                config: { ...TRACKER_SELECT_CONFIG, service: trackerAssignmentApiService },
                customErrorMessage: 'Vui lòng chọn Tracker'
            },
            {
                key: 'fromDate',
                label: 'Ngày bắt đầu',
                required: true,
                width: 'half',
                type: 'datepicker',
                placeholder: 'Chọn ngày bắt đầu phân công',
                customErrorMessage: 'Vui lòng chọn ngày bắt đầu'
            },
            {
                key: 'toDate',
                label: 'Ngày kết thúc',
                required: false,
                width: 'half',
                type: 'datepicker',
                placeholder: 'Chọn ngày kết thúc (tùy chọn)'
            }
        ]
    };
};

